import React, { useContext } from 'react'
import { StepHandlerContext } from '../../contexts/stepHandler.context'

import './previous-arrow.styles.scss'

const PreviousArrow = ({ color }) => {
  const { previousStep } = useContext(StepHandlerContext)

  return (
    <div className='previous-arrow' onClick={previousStep}>
      <svg
        viewBox='0 0 21 16'
        width='21px'
        height='16px'
        xmlns='http://www.w3.org/2000/svg'
        style={{ stroke: color }}
      >
        <path d='M 1.5 7.999 L 19.5 7.999' />
        <path d='M 8.045 14.545 L 1.5 8 L 8.045 1.455' />
      </svg>
    </div>
  )
}

export default PreviousArrow
